import React from 'react';
import { connect } from 'dva';
import { injectIntl } from 'react-intl';
import RoomReport from '../components/report/RoomReport';

export default connect(state => ({ ...state, loading: state.loading.global }))(
  injectIntl(({ roomReport, loading, intl, dispatch }) => {
    return (
      <div className="container-left">
        <RoomReport
          intl={intl}
          dispatch={dispatch}
          roomReport={roomReport}
          loading={loading}
        />
      </div>
    );
  })
);



// WEBPACK FOOTER //
// ./src/routes/RoomReport.js